.customer-organization-form__end-of-lease-inputs-container {
  width: 360px;
}
